export default __webpack_public_path__ + "static/media/blackbird1.33c8436d.jpg";